export default __webpack_public_path__ + "static/media/IMPRINT.849fcca2.pdf";